import { useUser } from '@increasecard/increase-core';
import { featureFlags } from '../featureFlags';

export function useIsAggregator(): boolean {
  const user = useUser();
  return !user?.isLegacyAccount() || featureFlags.isAggregator;
}
